import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { Attending } from '../../model/attending';
import { DispatchService } from '../../service/dispatch.service';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { AutoEletric } from '../../../shared/model/auto-eletric';
import { AutoEletricService } from '../../../shared/service/auto-eletric.service';
import { ToastService } from '../../../shared/service/toast.service';
import { JiraTicketService } from '../../../appraisal/service/jira-ticket.service';
import { MaterializeAction } from 'angular2-materialize';
import * as datePickerOptions from '../../../core/date-picker-options';
import * as moment from 'moment';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';

declare var Materialize: any;

@Component({
  selector: 'tx-dispatch',
  templateUrl: './dispatch.component.html',
  styleUrls: ['./dispatch.component.css']
})
export class DispatchComponent implements OnInit, AfterViewChecked {
  private _attending: Attending = new Attending();
  userAutoEletrics: Array<AutoEletric>;
  argosAutoEletrics: Array<any>;
  autoEletricAttributesTree = ['name'];
  autoEletricsResultLimit = 3;
  @Input() editable: boolean;
  @Output() txOnSave: EventEmitter<any> = new EventEmitter();
  @Output() txOnCancel: EventEmitter<any> = new EventEmitter();
  datePickerFormat = datePickerOptions.minDatePicker;

  shippingCompanies: Array<any>;
  DISPATCH = 'DISPATCH';
  authenticatedUser: any;
  schedulingDateActions = new EventEmitter<string|MaterializeAction>();
  estimatedDate = null;
  realDate = null;
  dispatchTicketInput: Subject<any>;
  showAutoeletricsSuggestion: Boolean = false;
  autoEletricId: any;

  constructor(private _dispatchService: DispatchService,
              private _authService: AuthenticationService,
              private _autoEletricService: AutoEletricService,
              private _toastService: ToastService,
              private _jiraTicketService: JiraTicketService) {
    this.dispatchTicketInput = new Subject<any>();
    this.findShippingCompanies();
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
    this._attending.dispatch.equipmentArrived = !!attending.dispatch.equipmentArrived;
    this.findArgosAutoEletrics();
    this.showStep();
    this.estimatedDate = moment(new Date(attending.dispatch.arrivalEstimatedDate)).format('DD/MM/YYYY');
    this.realDate = moment(new Date(attending.dispatch.arrivalRealDate)).format('DD/MM/YYYY');
  }

  save() {
    if (this.autoEletricId != null) {
      let associateAutoEletric = {'attendingInfoId': this.attending.attendingInfo.id, 'autoEletricId': this.autoEletricId,
        'autoEletricStep': 'DISPATCH', 'suggestedByArgos': true};
      this.attending.dispatch.associateAutoeletric = associateAutoEletric;
    }
    this.attending.dispatch.arrivalEstimatedDate = moment(`${this.estimatedDate}`, 'DD/MM/YYYY');
    this.txOnSave.emit(this.attending);
  }

  cancel() {
    this.txOnCancel.emit();
  }

  findAutoEletric(name) {
    if (this.canEdit()) {
      this._autoEletricService.findByName(name);
    }
  }

  setEquipmentShippingStatus() {
    this.attending.dispatch.equipmentArrived = !this.attending.dispatch.equipmentArrived;
  }

  findArgosAutoEletrics() {
    if (this.attending.screening.providedServices.length > 0 && this.canEdit()) {
      this._autoEletricService
        .findBests(this.getSearchParams())
        .subscribe(
          autoEletrics => this.argosAutoEletrics = autoEletrics,
          error => this.showMessage(error.text)
        );
    }
  }

  selectAutoEletric(autoEletric) {
    if (this.autoEletricId === autoEletric.id) {
      this.autoEletricId = null;
    } else {
      this.autoEletricId = autoEletric.id;
    }
  }

  canEdit() {
    return (this.attending.dispatch.canEdit || this.attending.dispatch.canEdit === undefined) && this.editable;
  }

  canView() {
    return this.attending.dispatch.canView && !this.canEdit();
  }

  canSetEquipmentArrived() {
    return this.attending.dispatch.id != null;
  }

  getObjectKeys(object) {
    if (object) {
      return Object.keys(object);
    }
    return [];
  }

  toggleDatePicker() {
    this.schedulingDateActions.emit({action: 'pickadate', params: ['open']});
  }

  showAutoeletrics() {
    this.showAutoeletricsSuggestion = true;
  }

  private setUpObservers() {

    this.setUpDispatchTicketInputObserver();

    this._autoEletricService.find$
      .filter(result => result instanceof Array)
      .subscribe(autoEletrics => this.userAutoEletrics = autoEletrics);
  }

  private getSearchParams() {
    return {
      providedServices: this.attending.screening.providedServices,
      branchId: this.attending.branch ? this.attending.branch.id : null,
      equipmentModelId: this.attending.screening.equipmentModel ? this.attending.screening.equipmentModel.id : null,
      resultLimit: this.autoEletricsResultLimit,
      accessoryMovementLogs: this.attending.accessoryMovementLogs
    };
  }

  private showStep() {
    if (this.attending.orderedSteps  && this.attending.currentStep === this.DISPATCH) {
      this.setIsVisible();
      this.setIsEditable();
    }
  }

  private setIsVisible() {
    if (this.attending.orderedSteps.includes(this.DISPATCH)
        && this.authenticatedUser.stepViews.find(view => view.stepViewType === this.DISPATCH)) {
      this.attending.dispatch.canView = true;
    } else {
      this.attending.dispatch.canView = false;
    }
  }

  private setIsEditable() {
    if (this.authenticatedUser.stepKeys.find(view => view.stepType === this.DISPATCH)) {
      this.attending.dispatch.canEdit = true;
    } else {
      this.attending.dispatch.canEdit = false;
    }
  }

  private findShippingCompanies() {
    this._dispatchService.findShippingCompanies()
      .subscribe(
        companies => this.shippingCompanies = companies,
        error => this.showMessage(error.text)
      );
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

  private setUpDispatchTicketInputObserver() {
    this.dispatchTicketInput
      .map((event: any) => event.target.value)
      .debounceTime(750)
      .distinctUntilChanged()
      .flatMap(search => Observable.of(search).delay(750))
      .subscribe(typedValue => {
        if (typedValue && typedValue !== '' && this.canEdit()) {
          this.findDispatchTicket(typedValue);
        }
      });
  }

  private findDispatchTicket(dispatchTicketCod) {

    this._jiraTicketService.find$
      .subscribe((dispatchTicket) => this.resolveDispatchTicket(dispatchTicketCod, dispatchTicket));

    this.resolveDispatchTicket(dispatchTicketCod, this._jiraTicketService.findJiraTicket(dispatchTicketCod));
  }

  private resolveDispatchTicket(dispatchTicketCod, dispatchTicket) {
    if (dispatchTicket) {
      if (dispatchTicket.invoiceNumber) {
        this.attending.invoiceNumber = dispatchTicket.invoiceNumber;
        this.attending.dispatch.dispatchTicket = dispatchTicketCod;
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/dispatch/dispatch.component.ts